import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { USER_FILTER_QUERY_KEY } from "search-filter/hooks/useUserSearchFilterQuery";
import { DEFAULT_PAGINATION } from "search-filter/components/filter-management-pages/FilterUsagesInSearches";
import PaginationURL from "util/PaginationURL";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const fetchSearchFilterUsages = async (filterId, { query, page, per_page, type }) => {
  const url = PaginationURL(
    `/plugins/org.graylog.plugins.searchfilters/search_filters_usage/details/${filterId}/paginated`,
    page,
    per_page,
    query,
    { type }
  );
  return fetch("GET", qualifyUrl(url));
};
const useSearchFilterUsagesQuery = (filterId, requestQuery) => useQuery({
  queryKey: [USER_FILTER_QUERY_KEY, filterId, requestQuery],
  queryFn: () => defaultOnError(
    fetchSearchFilterUsages(filterId, requestQuery),
    i18n.t("notifications.load_filter_usages_failed", { ns: "enterprise_search", filterId }),
    i18n.t("notifications.load_filter_usages_failed_title", { ns: "enterprise_search" })
  ),
  placeholderData: keepPreviousData,
  initialData: {
    elements: [],
    pagination: DEFAULT_PAGINATION
  }
});
export default useSearchFilterUsagesQuery;
